import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TorreControlTransporteService } from '../../services/torre-control-transporte.service';

/** URL fallback si el backend no retorna baseUrl */
const TORRE_CONTROL_DEFAULT_BASE_URL = 'https://opbs.opb.cl/torrecontrol';

@Component({
    selector: 'app-torre-control-transporte',
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatProgressSpinnerModule,
    ],
    templateUrl: './torre-control-transporte.component.html',
    styleUrl: './torre-control-transporte.component.scss',
})
export class TorreControlTransporteComponent implements OnInit {
    /** URL para abrir en nueva pestaña */
    torreControlUrl = TORRE_CONTROL_DEFAULT_BASE_URL;

    /** URL sanitizada para el iframe */
    torreControlSafeUrl: SafeResourceUrl;

    /** Cargando mientras se obtiene el token */
    loadingToken = true;

    /** Error al obtener token */
    tokenError: string | null = null;

    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly torreControlService: TorreControlTransporteService
    ) {
        this.torreControlSafeUrl =
            this.sanitizer.bypassSecurityTrustResourceUrl(
                TORRE_CONTROL_DEFAULT_BASE_URL
            );
    }

    ngOnInit(): void {
        // Todos los usuarios (cliente, admin, operador) solicitan token y usan iframe embed
        // Backend retorna token con clientId/nombre según rol
        this.torreControlService.getToken().subscribe({
            next: (res) => {
                this.loadingToken = false;
                const token = res?.token;
                const baseUrl = res?.baseUrl || TORRE_CONTROL_DEFAULT_BASE_URL;
                if (token) {
                    const embedUrl = `${baseUrl}/embed?token=${encodeURIComponent(
                        token
                    )}&theme=dark`;
                    this.torreControlUrl = embedUrl;
                    this.torreControlSafeUrl =
                        this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
                } else {
                    this.torreControlUrl = baseUrl;
                    this.torreControlSafeUrl =
                        this.sanitizer.bypassSecurityTrustResourceUrl(baseUrl);
                }
            },
            error: (err) => {
                this.loadingToken = false;
                const message = err?.message;
                if (message) {
                    this.tokenError = message;
                } else if (err?.status === 404) {
                    this.tokenError =
                        'Endpoint de token no disponible. Puede abrir la Torre de Control en nueva pestaña.';
                } else {
                    this.tokenError =
                        'No se pudo obtener el token. Puede abrir la Torre de Control en nueva pestaña.';
                }
                this.torreControlUrl = TORRE_CONTROL_DEFAULT_BASE_URL;
                this.torreControlSafeUrl =
                    this.sanitizer.bypassSecurityTrustResourceUrl(
                        TORRE_CONTROL_DEFAULT_BASE_URL
                    );
            },
        });
    }
}
